import type {ProductDetails} from '../models/ProductDetails';
import {ProductTagsUI} from './ProductTagsUI';
import {AddToFavoritesButton} from '../features/AddToFavoritesButton';
import React, {useState} from 'react';
import type {ProductPrice} from '../../catalog/models/ProductPrice';
import {ProductPriceUI} from './ProductPriceUI';
import TruncateTooltipUI from '../../common/ui/TruncateTooltipUI';
import {findItemAvailability} from '../../catalog/domain/CatalogService';
import {AvailabilityUI} from '../../common/ui/AvailabilityUI';

interface Props {
  data: {
    details: {
      value: ProductDetails;
      loading: boolean;
      error: any; // TODO: use the correct type
    };
    price: {
      value: ProductPrice;
      loading: boolean;
      error: any; // TODO: use the correct type
    };
  },
  actions: {
    onClick: (details: ProductDetails) => void;
  }
}

export const ProductCardUI = ({ data, actions }: Props) => {
  const [isHovered, setIsHovered] = useState(false);
  const { details, price } = data;

  const availability = findItemAvailability(details.value);

  return (
    <div className={`card border-0 shadow-sm ${price.loading && 'shimmer'}`}
         style={{ width: '270px', height: '390px', cursor: 'pointer' }}
         onClick={() => actions.onClick(details.value)}
         onMouseEnter={() => setIsHovered(true)}
         onMouseLeave={() => setIsHovered(false)}
    >
      <div className="card-header border-0 bg-white">
        <ProductTagsUI productDetails={details.value} />
      </div>

      <div className="card-img-top">
        <div className="d-flex justify-content-center align-items-center">
          <div className="position-absolute">
            <AddToFavoritesButton data={{
              productCode: details.value.pro_codigo,
              show: isHovered,
              isFavorite: details.value.isFavorite
            }} />
          </div>
          <img src={details.value.pro_imagen}
               className="rounded-2 p-2"
               style={{ height: '170px', width: 'auto' }}
               alt="Imagen del producto"
          />
        </div>
      </div>

      <div className="card-body">
        <div className="d-flex flex-align-start flex-column h-100">
          <div className="h-100 mb-auto overflow-visible">
            <div className="card-title">
              <TruncateTooltipUI text={details.value.pro_nombre} maxLength={40} />
            </div>

            <div className="card-subtitle text-muted">
              <small>{details.value.pro_laboratorio}</small>
            </div>
          </div>

          <div className="card-text">
            <div className="d-flex flex-column gap-2">
              <AvailabilityUI data={{ availability: availability }} />
              <ProductPriceUI loading={price.loading} error={price.error} price={price.value} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};